import Autocomplete from 'autocomplete.js';

/** @typedef { import('./Autocomplete').AutocompleteOptions } AutocompleteOptions */

/** @typedef { import('./Autocomplete').AutocompleteDataset } AutocompleteDataset */

/**
 * @param {HTMLInputElement} input
 * @param {AutocompleteOptions} options
 * @param {AutocompleteDataset[]} sources
 */
export function createAutocomplete(input, options, sources) {
    return new Autocomplete(input, options, sources);
}

export const VueAutocomplete = {
    props: {
        options: Object,
        datasets: Array,
    },
    methods: {
        initAutocomplete() {
            return createAutocomplete(this.$el, this.$options.autocompleteOptions, this.$options.autocompleteDatasets);
        }
    },
    created() {
        this.$options.autocompleteOptions = this.options || {};
        this.$options.autocompleteDatasets = this.datasets || [];
    },
    mounted() {
        this.$options.autocomplete = this.initAutocomplete();
    },
    destroyed() {
        this.$options.autocomplete.destroy();
    },
    render(h) {
        return <input/>;
    },
}
